export default "/close-button.e8c528af8f9fe4e80d1fc1b30bb09c38.png";